import Link from "next/link";
import React from "react";
import Button, { ButtonProps } from "./Button";
import styles from "./Button.module.scss";

interface LinkButtonProps extends ButtonProps {
    href: string;
}

const LinkButton: React.FC<LinkButtonProps> = (props) => {
    const isExternalUrl = props.href[0] !== "/";
    const openInNewTabProps = isExternalUrl && {
        rel: "noreferrer",
        target: "_blank",
    };
    return (
        <Link
            href={props.href}
            scroll={false}
            className={styles.linkButton}
            {...openInNewTabProps}>

            <Button {...props} />

        </Link>
    );
};

export default LinkButton;
